import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/juicybet/images/logoFooter.png';

export default function index() {
  return <Image src={footerLogo} maxW="174px" mt="3" />;
}
